module.exports = __webpack_public_path__ + "static/media/Follower_Button-1.50f46b27.png";